import { Node } from '@tiptap/core';

/**
 * TipTap inline node for param/variable chips (e.g. @candidate_name).
 * Renders as span.param-chip so it matches ParamTextarea styling (with remove button).
 * Serializes with data-key so HTML round-trips and matches {{key}} semantics.
 */
export const ParamChipExtension = Node.create({
  name: 'paramChip',

  group: 'inline',
  inline: true,
  atom: true,
  selectable: true,

  addAttributes() {
    return {
      paramKey: {
        default: null,
        parseHTML: element =>
          element.getAttribute('data-key') || element.getAttribute('data-param'),
        renderHTML: attributes => ({
          'data-key': attributes.paramKey,
        }),
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'span.param-chip',
        getAttrs: dom => ({
          paramKey: dom.getAttribute('data-key') || dom.getAttribute('data-param') || null,
        }),
      },
    ];
  },

  renderHTML({ node }) {
    const key = node.attrs.paramKey || '';
    return [
      'span',
      {
        class: 'param-chip',
        'data-key': key,
        contenteditable: 'false',
      },
      `@${key}`,
      [
        'span',
        {
          class: 'param-chip-remove',
          role: 'button',
          tabindex: '-1',
          'aria-label': 'Remove',
        },
        '×',
      ],
    ];
  },

  addNodeView() {
    return ({ editor, node, getPos }) => {
      const dom = document.createElement('span');
      dom.className = 'param-chip';
      dom.setAttribute('contenteditable', 'false');
      dom.setAttribute('data-key', node.attrs.paramKey || '');

      const label = document.createTextNode(`@${node.attrs.paramKey || ''}`);
      dom.appendChild(label);

      const removeBtn = document.createElement('span');
      removeBtn.className = 'param-chip-remove';
      removeBtn.setAttribute('role', 'button');
      removeBtn.setAttribute('tabindex', '-1');
      removeBtn.setAttribute('aria-label', 'Remove');
      removeBtn.textContent = '×';
      removeBtn.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();
        const pos = typeof getPos === 'function' ? getPos() : getPos;
        if (typeof pos === 'number' && editor?.view) {
          const { state, view } = editor;
          const tr = state.tr.delete(pos, pos + node.nodeSize);
          view.dispatch(tr);
          editor.chain().focus().run();
        }
      });
      dom.appendChild(removeBtn);

      return { dom };
    };
  },
});
